import { getCsrfToken } from 'util/authenticityToken';

export type CreateCitationImportParams = {
  reviewId: string;
  s3Path: string;
  filename: string;
  studyCategory: string;
  citationImportSourceName?: string;
};

export type CreateCitationImportResponse = {
  success: boolean;
  redirect_url?: string;
  errors?: string[];
};

/**
 * Creates a citation import record on the backend after file upload.
 * Uses the existing Reviews::CitationImportsController#create action.
 */
export const createCitationImport = async (
  params: CreateCitationImportParams
): Promise<CreateCitationImportResponse> => {
  const csrfToken = getCsrfToken();

  const requestBody = {
    filename: params.filename,
    s3_path: params.s3Path,
    citation_import: {
      study_category: params.studyCategory,
      ...(params.citationImportSourceName && {
        citation_import_source_name: params.citationImportSourceName,
      }),
    },
  };

  const response = await fetch(`/reviews/${params.reviewId}/citation_imports`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify(requestBody),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({
      errors: ['Failed to create citation import'],
    }));
    throw new Error(
      errorData.errors?.join(', ') || 'Failed to create citation import'
    );
  }

  return response.json();
};
